var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mostrarBtn)?_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.exportar()}}},[_c('i',{staticClass:"fa fa-file-pdf-o ml-2"}),_vm._v(" Exportar ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }